import { LuCopyright } from "react-icons/lu";

const Footer = () => {
  return <div className="border-t bg-white py-1 text-xs sm:text-sm w-full fixed flex justify-center items-center z-10 bottom-0">
    VoterSync&nbsp; <LuCopyright /> &nbsp;{new Date().getFullYear()} .
    All rights reserved by Flint Infotech LLP
  </div>
}
 
export default Footer;